function History() {
  return <h1>История</h1>;
}

export default History;
